<template>
  <md-popup
      :value="show"
      class="comment-input-wrap"
      @hide="$emit('close')"
      position="bottom"
  >
    <div class="friends-wrap all-user" v-if="isSearchingFriend">
      <div class="friends-item"
           @click="toggleAccount(item.uid || item.account, item.nick_name, item)"
           v-for="item in searchUsers" :key="item.uid">
        <img class="avatar" :src="item.avatar" alt="">
        <!--        <img v-show="selected.includes(item.account)" src="../Comment/assets/selected-friends.png" alt="" class="selected">-->
        <span>{{ item.nick_name || item.nick }}</span>
      </div>

      <div class="no-friends" v-if="!searchUsers.length && !loading">{{ $t('noFriends') }}</div>
    </div>
    <div class="friends-wrap" v-if="isShowFriend && isShowFriendWrap">
      <div class="friends-item"
           @click="toggleAccount(item.account, item.nick, item)"
           v-for="item in filterFriends" :key="item.account">
        <img class="avatar" :src="item.avatar" alt="">
        <!--        <img v-show="selected.includes(item.account)" src="../Comment/assets/selected-friends.png" alt="" class="selected">-->
        <span>{{ item.nick }}</span>
      </div>

      <div class="no-friends" v-if="!filterFriends.length">{{ $t('noFriends') }}</div>
    </div>

    <div class="input-wrap">
      <div class="content-wrap">
        <div id="editor"></div>
        <div class="action-wrap">
          <!-- <img v-show="isShowFriendWrap" class="refer" @click="onCloseFriend" src="../Comment/assets/@.png" alt=""> -->
          <img v-show="isShowEmoji" @click="isOpenEmoji = !isOpenEmoji"
               class="emoji" :src="emojiIcon" alt="">
          <img v-show="isShowUpload" @click="pickImage" class="send-image" src="../Comment/assets/send-image.png" alt="">
        </div>
      </div>
      <img @click="doComment" class="send-comment" src="../Comment/assets/send.png" alt="">
    </div>
    <div class="file-send" v-if="fileSend.url">
      <div class="img-wrap">
        <img class="close" src="../Comment/assets/delete-image.png" @click="fileSend = {}, isSending = false" alt="">
        <img class="img" :src="fileSend.url" alt="">
      </div>
    </div>
    <div class="emoji-wrapper" v-show="isOpenEmoji">
      <div class="emoji-container">
        <img :src="require(`@/assets/emoji/${item.file}`)"
             @click="insertEmoji(item.tag, item.file)"
             v-for="item in emojiData"
             :key="item.id"
             alt="">
      </div>
    </div>

    <input type="file" id="comment-file" accept="image/png, image/gif, image/jpeg"
           @change="fileChange($event)">
  </md-popup>
</template>

<script>
import Quill from 'quill';
import 'quill/dist/quill.bubble.css';
import Mention from './Mension';
import Emoji from './Emoji';
import emojiData from '@/utils/emoji';
import { searchUser } from '@api/im';

Quill.register('formats/mention', Mention);
Quill.register('formats/emoji', Emoji);

let quill;

export default {
  name: 'RickTextComment',
  props: {
    replyName: String,
    showPopup: {
      type: Boolean,
      default: false
    },
    isShowEmoji: {
      type: Boolean,
      default: true
    },
    isShowUpload: {
      type: Boolean,
      default: true
    },
    isShowFriendWrap: {
      type: Boolean,
      default: true
    },
    isOpenEmojiRich: {
      type: Boolean,
      default: false
    },
    isFileSendRich: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emojiData,
      show: false,
      fileSend: {},
      isSending: false,
      isOpenEmoji: false,
      isSearchingFriend: false,
      position: 0,
      searchUsers: [],
      loading: false,
      searchingFriendPosition: false,
      debounceHolder: null,
      searchingFriendText: '',
      isShowFriend: false
    };
  },
  computed: {
    ...mapState('message', ['friends', 'usersInfo']),
    ...mapState('user', ['userInfo']),
    ...mapGetters('message', ['getTargetUserInfo']),
    filterFriends () {
      if (this.searchingFriendText) {
        return this.filterUsers.filter(item =>
          item.nick.includes(this.searchingFriendText));
      } else {
        return this.filterUsers;
      }
    },
    emojiIcon () {
      if (this.isOpenEmoji) {
        return require('../Comment/assets/emoji-s.png');
      } else {
        return require('../Comment/assets/emoji.png');
      }
    },
    filterUsers () {
      return this.usersInfo.filter(item => this.friends.find(sub => sub.account === item.account));
    }
  },
  created () {
    this.show = true;
    if (this.isOpenEmojiRich) {
      this.isOpenEmoji = true;
    }
  },
  mounted () {
    this.initQuill();
    if (this.isFileSendRich && document.querySelector('#comment-file')) {
      document.querySelector('#comment-file').click();
    }
  },
  watch: {
    showPopup () {
      if (!this.showPopup) {
        quill.setContents([]);
        this.isShowFriend = false;
        this.isSearchingFriend = false;
      }
    },
    searchingFriendText () {
      this.doSearchUsers();
    }
  },
  methods: {
    ...mapActions('home', ['upload']),
    ...mapMutations('publicStore', ['setLoadingShowFlag']),
    onCloseFriend () {
      // if (this.isShowFriend || this.isSearchingFriend) {
      //   this.isShowFriend = false;
      //   this.isSearchingFriend = false;
      // } else {
      //   this.isShowFriend = true;
      // }
      this.$emit('share');
      this.$router.push('/invite');
    },
    doComment () {
      const contents = quill.getContents();

      if (!contents.ops.filter(item => item.insert !== '\n').length && !this.fileSend.path) {
        this.$toast.failed(this.$t('commentEnterTextOrImage'));
        return;
      }

      const centos = {
        users: [],
        text: '',
        pic: this.fileSend.path
          ? [{
              url: this.fileSend.path
            }]
          : ''
      };

      const users = {};

      contents.ops.forEach((item) => {
        if (item.insert.emoji) {
          const { emoji } = item.insert;
          centos.text += emoji.tag;
        } else if (item.insert.mention) {
          const { mention } = item.insert;
          if (!users[mention.id]) {
            users[mention.id] = mention.value;
            centos.users.push({
              nick_name: mention.value.trim(),
              uid: mention.id
            });
          }
          centos.text += ` @${mention.value} `;
        } else if (typeof item.insert === 'string') {
          centos.text += item.insert;
        }
      });

      centos.text = centos.text.replace(/\n$/g, '');
      centos.url = this.fileSend.url;
      this.show = false;
      this.$emit('comment', centos);
      // quill.setContents([{
      //   insert: '\n'
      // }]);
    },
    pickImage () {
      if (!this.isSending) {
        document.querySelector('#comment-file').click();
      }
    },
    insertEmoji (tag, file) {
      const ops = [
        {
          insert: {
            emoji: {
              url: require(`@/assets/emoji/${file}`),
              width: '14px',
              height: '14px',
              tag
            }
          }
        }];
      if (this.position > 0) {
        ops.unshift({
          retain: this.position
        });
      }

      quill.updateContents(ops);
      this.position += 1;
      quill.setSelection(this.position, 0);
    },
    async uploadFile (file, type, name) {
      const res = await this.upload({ file, type, name });
      return res.data.info;
    },
    fileChange (event) {
      if (event.target.files.length) {
        this.isSending = true;
        this.uploadFile(event.target.files[0])
          .then(res => {
            // 这样可以准许用户再次选择同一张图片
            event.target.value = '';
            this.fileSend = res;
          });
      }
    },
    initQuill () {
      quill = new Quill('#editor', {
        theme: 'bubble',
        modules: {
          // 配置工具栏模块
        },
        placeholder: this.replyName ? `回复:${this.replyName}` : this.$t('commentPlaceholder')
      });
      setTimeout(() => {
        quill.focus();
      }, 1000);
      quill.on('text-change', (delta, oldDelta, source) => {
        if (!quill.getText()) {
          this.isSechingFriend = false;
          return;
        }

        if (source !== 'user') {
          return;
        }

        const selection = quill.getSelection();
        if (selection) {
          this.position = selection.index;
        }

        if (delta.ops.find(item => item.insert === '@')) {
          this.searchUsers = this.filterUsers;
          this.isSearchingFriend = true;
          this.isShowFriend = false;
          this.searchingFriendPosition = delta.ops.length === 1 ? 0 : delta.ops[0].retain;
        } else if (this.isSearchingFriend) {
          if (delta.ops.find(item => typeof item.delete === 'number')) {
            if (this.searchingFriendText.length) {
              this.searchingFriendText = this.searchingFriendText.substring(0, this.searchingFriendText.length - 1);
            } else if (quill.getSelection().index === this.searchingFriendPosition) {
              this.isSearchingFriend = false;
              this.searchingFriendPosition = 0;
            }
          } else {
            this.searchingFriendText += delta.ops[1].insert;
          }
        }
      });
    },
    async doSearchUsers () {
      if (!this.searchingFriendText) {
        this.searchUsers = this.filterUsers;
        this.setLoadingShowFlag(false);
        clearTimeout(this.debounceHolder);
        return;
      }

      if (this.debounceHolder) {
        this.searchUsers = [];
        this.loading = true;
        clearTimeout(this.debounceHolder);
      }

      this.debounceHolder = setTimeout(async () => {
        const { result, data } = await searchUser({
          content: this.searchingFriendText.replace(/[ |']/g, '')
        });

        this.loading = false;

        this.setLoadingShowFlag(false);
        if (result === 200000) {
          this.searchUsers = data.list.list;
        }
      }, 600);
    },
    toggleAccount (account, nickName) {
      let uid = '';
      let nick = '';
      if (this.isSearchingFriend && this.searchingFriendText) {
        uid = account;
        nick = nickName;
      } else {
        const user = this.getTargetUserInfo(account);
        uid = JSON.parse(user.custom).uid;
        nick = user.nick;
      }
      if (this.isSearchingFriend) {
        quill.deleteText(this.searchingFriendPosition, quill.getLength() - 1);
        quill.insertEmbed(this.searchingFriendPosition, 'mention', {
          denotationChar: '@',
          index: 0,
          id: uid,
          value: nick + ' '
        }, 'api');
        this.isSearchingFriend = false;
        this.searchingFriendPosition = 0;
      } else {
        quill.insertEmbed(this.position, 'mention', {
          denotationChar: '@',
          index: 0,
          id: uid,
          value: nick + ' '
        }, 'api');
      }

      this.searchingFriendText = '';
      this.position++;
      quill.setSelection(this.position, 0);
      this.isShowFriend = false;
    }
  }
};
</script>

<style scoped lang="scss">
.comment-input-wrap {
  position: absolute;
  z-index: 1000;

  /deep/ .md-popup-box {
    padding: 0 !important;
  }

  .input-wrap {
    display: flex;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    padding: 10px;
    align-items: flex-end;
    background: #1c1e23;
    .content-wrap {
      width: 312px;
      min-height: 70px;
      background: #393948;
      border-radius: 26px;
      margin-right: 14px;
      padding: 13px 15px 5px 13px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #FFFFFF80;
      /deep/ .ql-editor {
        padding: 0 !important;

        img {
          display: unset;
        }

        .ql-emoji {
          transform: translateY(2px);
        }

        &::before {
          left: 0;
          color: #FFFFFF80;
          font-style: normal;
        }

        font-family: 'PingFang SC';
        font-size: 14px;

        .ql-mention {
          color: #32B8AF;
          font-style: normal;
        }
      }
    }

    .action-wrap {
      display: flex;
      width: 100%;
      justify-content: flex-end;

      img {
        margin-left: 10px;
      }
    }

    img {
      width: 24px;
      height: 24px;
    }

    .send-comment {
      margin-bottom: 10px;
    }
  }

  .emoji-wrapper {
    height: 299px;
    max-width: 345px;
    overflow-y: auto;
    position: relative;
    background: #1C1E23;
    .emoji-action {
      display: flex;
      position: absolute;
      right: 8px;
      border-radius: 41px;
      align-items: center;

      div {
        width: 63px;
        height: 29px;
        border-radius: 27px;
        background-color: #fff;
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 20px;
          height: 20px;
        }

        &:last-child {
          background: #32B8AF;
        }

        &.disabled {
          opacity: 0.7;
        }
      }
    }

    .text {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 12px;
      color: rgba(255, 255, 255, 0.6);
      margin-bottom: 12px;
    }

    .emoji-container {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      gap: 12px;
      margin-bottom: 18px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .file-send {
    margin-top: 10px;
    position: relative;

    .img-wrap {
      position: relative;
      display: flex;
      width: 60px;

      .close {
        position: absolute;
        top: 1px;
        right: 1px;
        height: 12px;
        width: 12px;
      }

      .img {
        width: 60px;
        border-radius: 6px;
        height: 60px;
        object-fit: contain;
      }
    }

  }
}

#comment-file {
  width: 0;
  height: 0;
  position: absolute;
  opacity: 0;
}

.friends-wrap {
  display: flex;
  overflow-x: auto;
  width: 100%;
  background-color: white;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  padding: 10px;
  transform: translateY(10px);

  .no-friends {
    text-align: center;
    width: 100%;
  }

  .friends-item {
    position: relative;
    width: 68px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
      margin-right: 10px;
    }

    &.active {
      .avatar {
        opacity: 0.4;
      }
    }

    .selected {
      width: 16px;
      height: 16px;
      top: 26px;
      position: absolute;
      left: 26px;
    }

    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 100%;
      margin-bottom: 8px;
    }

    span {
      display: block;
      width: 100%;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

  }

}

</style>
